export const reducer =(state,{type,action})=>{
    switch(type){
        case 'pluse' : return state;
        default: return state
    }
}